export const maxVisible = 5
export const dotsListWidth = 41
export const centerOffset = 17.5
export const dotSpacing = 8
export const adjacentDistance = 2
